<template><div /></template>
<script>

import { mapState } from 'vuex'
export default {
  name: 'poi-marker',
  props: ['google','map','poi','editable','coords'],
  data() {
    return {
      widget: null,
      cc: [null, null],
    }
  },
  computed: {
    visible() { return this.getVisible() },
    zIndex() {
      if (this.poi.id === this.$store.state.selectedPoi)
        return 1000 
      return 900
    },
    bounds() {
      let b = new this.google.maps.LatLngBounds()
      if (this.widget) {
        if ('getBounds' in this.widget)
          b.union(this.widget.getBounds())
        else if ('getPosition' in this.widget)
          b.extend(this.widget.getPosition())
      }
      return b
    },
    coordsActive() {
      return !this.$store.state.filterUnitName && !this.$store.state.selectedUnit
    },
  },
  watch: {
    'poi.model.0.0': function(nv,ov) { this.configWidget() },
    //'poi.model.1': function() { this.configWidget() }, // TODO setCenter/setPosition
    //'poi.model.2': function() { this.configWidget() }, // TODO setCenter/setPosition
    //'poi.model.3': function() { this.configWidget() }, // TODO setRadius
    bounds(nv) { this.$store.commit('updatePoiBounds', { pid: this.poi.id, bounds: nv }) },
    visible(nv) {
      if (this.widget) {
        this.widget.setVisible(nv)
        this.updateCoords()
      }
    },
    coords() {
      this.updateCoords(true)
      this.updateCoords()
    },
    coordsActive(nv) {
      this.updateCoords()
    },
  },
  methods: {
    updateCoords(purge) {
      let ncc = [ null, null ]
      if (this.visible && !purge && this.coordsActive) {
        if (this.widget) {
          if ('getBounds' in this.widget) {
            let b = this.widget.getBounds(),
              ne = b.getNorthEast(),
              sw = b.getSouthWest()
            ncc = [
              { lat: ne.lat(), lng: ne.lng() },
              { lat: sw.lat(), lng: sw.lng() },
            ]
          } else if ('getPosition' in this.widget) {
            let p = this.widget.getPosition()
            ncc = [ { lat: p.lat(), lng: p.lng() }, null ]
          }
        }
      }
      for (let i=0; i<2; i++) {
        if (ncc[i]) {
          if (this.cc[i]) {
            this.cc[i].coords.update(ncc[i])
          } else if (this.coords) {
            this.cc[i] = this.coords.create(ncc[i].lat, ncc[i].lng)
            this.cc[i].coords = this.coords
          }
        } else if (this.cc[i]) {
          this.cc[i].coords.remove(this.cc[i])
          this.cc[i] = null
        }
      }
    },
    getVisible() { return this.$store.getters.is_pid_visible(this.poi.id) },
    click() {
      this.$store.commit('selectPoi', this.poi.id)
      /*
      let lat = this.poi.model[0][1],
        lng = this.poi.model[0][2],
        w = new this.google.maps.InfoWindow({
          content: `<a target="_blank" class="directions" href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}">Get directions to ${this.poi.name}</a>`
        })
      w.open(this.map, this.widget)
      */
    },
    mouseover() { this.$store.commit('hoverPoi', this.poi) },
    mouseout() { this.$store.commit('hoverPoi', null) },
    configWidget(clear) {
      if (this.widget) {
        this.google.maps.event.clearInstanceListeners(this.widget)
        this.widget.setMap(null)
        this.widget = null
      }
      if (clear) {
        this.updateCoords()
        return
      }
      let m = this.poi.model
      if (!(m.length >= 1)) {
        this.updateCoords()
        return
      }
      m = m[0]
      switch (m[0]) {
      case 'circle':
        this.widget = new this.google.maps.Circle({
          map: this.map,
          strokeWeight: 0,
          fillColor: '#00ff00',
          fillOpacity: .35,
          center: { lat: m[1], lng: m[2] },
          radius: m[3],
          zIndex: this.zIndex,
          editable: this.editable,
          visible: this.visible,
        })
        this.google.maps.event.addListener(this.widget, 'center_changed', () => {
          this.$store.commit('hoverPoi', null)
          this.$emit('noAutoZoom', null)
          const c = this.widget.getCenter()
          this.$set(this.poi.model[0], 1, c.lat())
          this.$set(this.poi.model[0], 2, c.lng())
        })
        this.google.maps.event.addListener(this.widget, 'radius_changed', () => {
          this.$store.commit('hoverPoi', null)
          this.$emit('noAutoZoom', null)
          const r = this.widget.getRadius()
          this.$set(this.poi.model[0], 3, r)
        })
        break
      case 'point':
        this.widget = new this.google.maps.Marker({
          map: this.map,
          position: { lat: m[1], lng: m[2] },
          zIndex: this.zIndex,
          draggable: this.editable,
          icon: {
            path: 'M -1,-1 1,-1 1,1 -1,1 z',
            fillColor: '#f00',
            fillOpacity: 1.0,
            strokeColor: '#fff',
            strokeWeight: 1,
            scale: 5,
          },
          visible: this.visible,
        })
        this.google.maps.event.addListener(this.widget, 'position_changed', () => {
          this.$store.commit('hoverPoi', null)
          this.$emit('noAutoZoom', null)
          const p = this.widget.getPosition()
          this.$set(this.poi.model[0], 1, p.lat())
          this.$set(this.poi.model[0], 2, p.lng())
        })
        break
      default:
        // unknown widget type
        this.widget = null
        break
      }
      this.google.maps.event.addListener(this.widget, 'click', this.click)
      this.google.maps.event.addListener(this.widget, 'mouseover', this.mouseover)
      this.google.maps.event.addListener(this.widget, 'mouseout', this.mouseout)
      this.updateCoords()
    },
  },
  created() { this.updateCoords() },
  mounted() {
    this.configWidget()
    this.$store.commit('updatePoiBounds', { pid: this.poi.id, bounds: this.bounds })
  },
  destroyed() {
    this.configWidget(true)
    this.updateCoords(true)
  },
}
</script>
